import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'

import { TConfirmationDialogContentProps } from './TConfirmationDialogContentProps'

import styles from './ConfirmationDialogContent.module.scss'

export const ConfirmationDialogContent = ({
  confirmBtnText,
  content,
  hasComment,
  isOnlyApply,
  isApplyDisabled,
  onConfirm,
  onReject,
  rejectBtnText,
  title,
  isApplyNegative = false,
}: TConfirmationDialogContentProps) => {
  const [comment, setComment] = useState('')

  const handleConfirm = useCallback(() => {
    onConfirm(comment)
  }, [comment, onConfirm])

  const handleReject = useCallback(() => {
    if (!isOnlyApply) {
      onReject(comment)
    }
  }, [comment, isOnlyApply, onReject])

  return (
    <div className={styles.content}>
      <div className={styles.title}>
        <h5 className={styles.title}>
          <Translation text={title} span />
        </h5>
      </div>
      <div>{typeof content === 'string' ? <Translation text={content} span /> : content}</div>
      {hasComment && (
        <Input
          classes={{
            root: styles.comment,
          }}
          type="text"
          label="Comment"
          onChange={setComment}
          value={comment}
        />
      )}
      <div className={styles.actions}>
        <Button
          onClick={handleConfirm}
          disabled={isApplyDisabled}
          color={isApplyNegative ? 'danger' : 'primary'}
        >
          <Translation text={confirmBtnText} span />
        </Button>

        {!isOnlyApply && (
          <Button onClick={handleReject} color="grey">
            <Translation text={rejectBtnText || 'Cancel'} span />
          </Button>
        )}
      </div>
    </div>
  )
}
